import { NgModule } from '@angular/core';
import { MsgSendComponent } from './msg-send/msg-send';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '../pipes/pipes.module';
import { IonicModule } from 'ionic-angular/index';
import { ChooseChatroomComponent } from './choose-chatroom/choose-chatroom';
import { AddKeywordComponent } from './add-keyword/add-keyword';
import { MyAlertComponent } from './my-alert/my-alert';
import { ContactWalletComponent } from './contact-wallet/contact-wallet';
import { NumberPagerComponent } from './number-pager/number-pager';
import { TextPagerComponent } from './text-pager/text-pager';
import { TableHeaderComponent } from './table-header/table-header';
import { WordSettingComponent } from './word-setting/word-setting';
import { MyPhotoClipComponent } from './my-photo-clip/my-photo-clip';
import { ChatroomItemComponent } from './chatroom-item/chatroom-item';
import { ChatroomContactComponent } from './chatroom-contact/chatroom-contact';
import { ExcContactComponent } from './exc-contact/exc-contact';
import { ChatroomPortraitComponent } from './chatroom-portrait/chatroom-portrait';
import { ContactItemComponent } from './contact-item/contact-item';
import { LargeSoruceComponent } from './large-soruce/large-soruce';
import { ShowVideoComponent } from './show-video/show-video';
import { AngularEchartsModule } from 'angular2-echarts/index';
import { IonicImageViewerModule } from 'ionic-img-viewer';
import { ChatroomPickerComponent } from './chatroom-picker/chatroom-picker';
import { FormAComponent } from './form-a/form-a';
import { SourceItemComponent } from './source-item/source-item';
import { ModalTypeQrComponent } from './modal-type-qr/modal-type-qr';
import { DalayTimerComponent } from './dalay-timer/dalay-timer';
import { ModalTypeTagComponent } from './modal-type-tag/modal-type-tag';
import { ScrollListComponent } from './scroll-list/scroll-list';
import { SearchHeaderComponent } from './search-header/search-header';
import { ModalTypeInputAComponent } from './modal-type-input-a/modal-type-input-a';
import { ModalTypeHelpComponent } from './modal-type-help/modal-type-help';
import { InfiniteScrollComponent } from './infinite-scroll/infinite-scroll';
import { SendTaskComponent } from './send-task/send-task';
import { AutoKeywordComponent } from './auto-keyword/auto-keyword';
import { TimeSelectBarComponent } from './time-select-bar/time-select-bar';
import { MemberHeadComponent } from './member-head/member-head';
import { MemberTagComponent } from './member-tag/member-tag';
import { HotWordComponent } from './hot-word/hot-word';
import { HotQuestionComponent } from './hot-question/hot-question';
import { MoodAnaComponent } from './mood-ana/mood-ana';
import { WordRecordComponent } from './word-record/word-record';
import { ExpandableHeaderComponent } from './expandable-header/expandable-header';
import { VipIntroComponent } from './vip-intro/vip-intro';
import { EssenceMaterialComponent } from './essence-material/essence-material';

@NgModule({
  declarations: [
    MsgSendComponent,
    ChooseChatroomComponent,
    AddKeywordComponent,
    MyAlertComponent,
    ContactWalletComponent,
    NumberPagerComponent,
    TextPagerComponent,
    TableHeaderComponent,
    WordSettingComponent,
    MyPhotoClipComponent,
    ChatroomItemComponent,
    ChatroomContactComponent,
    ExcContactComponent,
    ChatroomPortraitComponent,
    ContactItemComponent,
    LargeSoruceComponent,
    ShowVideoComponent,
    ChatroomPickerComponent,
    FormAComponent,
    SourceItemComponent,
    SearchHeaderComponent,
    ModalTypeQrComponent,
    DalayTimerComponent,
    ModalTypeTagComponent,
    ScrollListComponent,
    ModalTypeInputAComponent,
    ModalTypeHelpComponent,
    InfiniteScrollComponent,
    SendTaskComponent,
    AutoKeywordComponent,
    TimeSelectBarComponent,
    MemberHeadComponent,
    MemberTagComponent,
    HotWordComponent,
    HotQuestionComponent,
    MoodAnaComponent,
    WordRecordComponent,
    ExpandableHeaderComponent,
    VipIntroComponent,
    EssenceMaterialComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    IonicModule,
    AngularEchartsModule,
    IonicImageViewerModule,
  ],
  exports: [
    MsgSendComponent,
    ChooseChatroomComponent,
    AddKeywordComponent,
    MyAlertComponent,
    ContactWalletComponent,
    NumberPagerComponent,
    TextPagerComponent,
    TableHeaderComponent,
    WordSettingComponent,
    MyPhotoClipComponent,
    ChatroomItemComponent,
    ChatroomContactComponent,
    ExcContactComponent,
    ChatroomPortraitComponent,
    ContactItemComponent,
    LargeSoruceComponent,
    ShowVideoComponent,
    ChatroomPickerComponent,
    FormAComponent,
    SourceItemComponent,
    SearchHeaderComponent,
    ModalTypeQrComponent,
    DalayTimerComponent,
    ModalTypeTagComponent,
    ScrollListComponent,
    ModalTypeInputAComponent,
    ModalTypeHelpComponent,
    InfiniteScrollComponent,
    SendTaskComponent,
    AutoKeywordComponent,
    TimeSelectBarComponent,
    MemberHeadComponent,
    MemberTagComponent,
    HotWordComponent,
    HotQuestionComponent,
    MoodAnaComponent,
    WordRecordComponent,
    ExpandableHeaderComponent,
    VipIntroComponent,
    EssenceMaterialComponent,
  ],
  entryComponents: [
    ModalTypeQrComponent,
    ModalTypeTagComponent,
    ModalTypeInputAComponent,
    ModalTypeHelpComponent,
  ],
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts